import _ from "lodash";
import store from "@/store/index";
import { camelizeKeys } from "humps";
import {
  storePatientQueueToken,
  fetchPatientQueueToken
} from "../helpers/patient_queue_token";
import BaseService from "./BaseService";

export default {
  fetch(patientQueueId) {
    let token = fetchPatientQueueToken();
    return BaseService.get(`patient_queues/${patientQueueId}?token=${token}`)
      .then(response => {
        let data = response.data.data;
        _.forEach(Object.keys(data.attributes.answers), key => {
          data.attributes.answers[key] = camelizeKeys(
            data.attributes.answers[key]
          );
        });
        store.dispatch("interview/setPatientQueue", data);
        store.dispatch("interview/setAnswers", data.attributes.answers);
        let path = data.attributes.path;
        if (path) {
          store.dispatch("interview/setPath", path);
        }
        return Promise.resolve(data.id);
      })
      .catch(errors => Promise.reject(errors));
  },

  create(interview_id, userToken) {
    return BaseService.post(`patient_queues`, {
      interview_id: interview_id,
      user_token: userToken
    })
      .then(response => {
        let data = response.data.data;
        store.dispatch("interview/setPatientQueue", data);
        if (data.attributes && data.attributes.token) {
          storePatientQueueToken(data.attributes.token);
        } else {
          // we have no auth token
          Promise.reject("No auth token");
        }
        return Promise.resolve(data.id);
      })
      .catch(errors => Promise.reject(errors));
  }
};
